//
//
//
//

import SimplePage from '@/components/SimplePage'
import {
  auth
} from "@utils/wechat";
import cookie from "@utils/store/cookie";
import {
  parseQuery
} from "@utils";
export default {
  name: "WxAuth",
  components: {
    SimplePage
  },
  created() {
  },
  mounted() {
    let pq = parseQuery();
    let query = this.$route.query;
    let _this = this;
    auth(pq.code, pq.state)
      .then((res) => {
        let url = cookie.get('login_back_url')
        location.href = url
      })
      .catch((res) => {
        console.log('catch', res)
      });
  }
};



// WEBPACK FOOTER //
// ./src/pages/WxAuth.vue